class Palette {
  constructor() {
    this._palette = [
      /* ['#78a5b6', '#807c70', '#6e472c', '#ad322c'],
       ['#2a6250', '#bab2a0', '#d8c9dd', '#883431'],
       ['#21243c', '#b7bc12', '#dc8808', '#96204f'],
       ['#e9e7d8', '#151412']*/
      ["#f1f0ea",
        "#e3d9c6",
        "#ebe7e0",
        "#b7b3a8",],
      ["#8c969d",
        "#50595e",
        "#3a3a3b",
        "#1a1919",],

      ["#917f69",
        "#b8a896",
        "#7e7a6d",
        "#908e7e",],

      ["#626058",
        "#1f3855",
        "#a78641",
        "#e15304",],

      ["#861a22",
        "#8a9977",
        "#4d6f39",]
    ];

    this._namePalette = [
      /*['Tiepolo', 'Ferro', 'Corteccia', 'Terracotta'],
      ['Bosco', 'Nebbia', 'Quarzo', 'Rubino'],
      ['Notta', 'Lime', 'Ocra', 'Bouganville'],
      ['Bianco', 'Nero']*/
      ["Bianco traffico",
        "Bianco perla",
        "Ghiaccio",
        "Grigio seta",],
      ["Grigio argento",
        "Grigio ferro",
        "Grigio grafite",
        "Nero",],

      ["Biscotto",
        "Cappuccino",
        "Tortora",
        "Argilla",],

      ["Muschio",
        "Bluzaffiro",
        "Mostarda",
        "Aranciopuro",],

      ["Rosso rubino",
        "Verde pallido",
        "Verde erba",],
    ];

    this._defaultBodyColor = this.hexToRgb(this._palette[0][0]);
    this._defaultBaseColor = this.hexToRgb(this._palette[0][0]);
    this._defaultFeetColor = this.hexToRgb(this._palette[0][0]);
    this._defaultTriangleColor = this.hexToRgb(this._palette[0][0]);

    this._defaultTexture = 'dist/assets/imports/textures/eros-e-psiche/EP1A.jpg'
  }

  rgbToName(rgb) {
    rgb = rgb.b | (rgb.g << 8) | (rgb.r << 16);
    const hex = '#' + (0x1000000 + rgb).toString(16).slice(1);

    return this.hexToName(hex);
  }

  hexToName(hex) {
    hex = hex.toLowerCase();
    let x = -1;
    let y = 0;
    for (y; y < this._palette.length; y++) {
      let valueToCheck = this._palette[y].indexOf(hex);
      if (valueToCheck !== -1) {
        x = valueToCheck;
        break;
      }
    }
    if (x !== -1) {
      return this._namePalette[y][x];
    } else {
      return hex;
    }
  }

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const rgb = result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;

    return rgb;
  }

  rgbToBabylon(customRgb) {
    return new BABYLON.Color3.FromInts(customRgb.r, customRgb.g, customRgb.b)
  }


}

export const palette = new Palette();
export default palette;

